import { render } from "./EditManufacturer.vue?vue&type=template&id=099e2ab1&ts=true"
import script from "./EditManufacturer.vue?vue&type=script&lang=ts"
export * from "./EditManufacturer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__